"use client";

import { useRouter } from "next/navigation";
import Combobox, { type ComboboxOption } from "@/components/frontend/ui/form/inputs/combobox";
import type { FormVariant } from "@/lib/types/form/form";

interface PropertyOverviewSortProps {
	basePath: string;
	filterQuery?: string;
	formVariant?: FormVariant;
	options: ComboboxOption[];
	sort?: string;
	onSortChange?: (sort: string) => void;
}

export function PropertyOverviewSort({ basePath, filterQuery, formVariant, options, sort, onSortChange }: PropertyOverviewSortProps) {
	const router = useRouter();

	return (
		<Combobox
			containerClassName="min-w-70"
			clearable={false}
			search={false}
			formVariant={formVariant}
			options={options}
			value={options.find((option) => option.value === sort) ?? options[0]}
			onValueChange={(option) => {
				if (!option) return;

				// Without a callback the results are server rendered, so the new sort
				// is applied by navigating; the client then takes over and refetches.
				if (onSortChange) {
					onSortChange(option.value);
					return;
				}

				const params = new URLSearchParams(filterQuery);
				params.delete("page");
				params.set("sort", option.value);
				router.push(`${basePath}?${params.toString()}`, { scroll: false });
			}}
		/>
	);
}
